import { render } from "./MainFooter.vue?vue&type=template&id=6be39b81"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/MainFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6be39b81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6be39b81', __exports__)) {
    api.reload('6be39b81', __exports__)
  }
  
  module.hot.accept("./MainFooter.vue?vue&type=template&id=6be39b81", () => {
    api.rerender('6be39b81', render)
  })

}


export default __exports__